// src/components/ResetPassword.jsx
import React, { useState } from 'react';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../firebase';
import './ResetPassword.css';

export default function ResetPassword() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');

  const handleReset = async (e) => {
    e.preventDefault();
    setStatus('');
    try {
      await sendPasswordResetEmail(auth, email);
      setStatus('✅ Password reset email sent. Please check your inbox.');
    } catch (err) {
      console.error(err);
      if (err.code === 'auth/user-not-found') {
        setStatus('❌ No user found with that email.');
      } else {
        setStatus('❌ Failed to send reset email. Try again.');
      }
    }
  };

  return (
    <div className="login-container">
      <h2>Reset Password</h2>
      <form onSubmit={handleReset} className="login-form">
        <label>Email:</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        {status && <p className="status-message">{status}</p>}
        <button type="submit">Send Reset Email</button>
        <p className="email-note">
          📬 If you don’t see the email, please check your spam or junk folder.
        </p>
      </form>
    </div>
  );
}

